
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { echartsJS } from "@/common/add-js";

import { getCurveBettery } from "@/api/api-charge-service";
import echartLine from "./echart-line.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    echartLine
  }
})
export default class PiSiteMonitor extends Vue {
  @Prop({ default: "" }) orderNo!: string;
  @Prop({
    default: () => {
      return {};
    }
  })
  infoData!: objAny;

  loaded = false;
  /**
   * 默认个度 60
   */
  second = 60;
  /**
   * 温度ichart特征
   */
  templateFeature = {
    // pileTempList: ["充电机温度(度)", "#4BA3F5"],
    // gunTempList: ["枪口温度(度)", "#6DDFCF"],
    // bsmTempList: ["BSM最高动力电池温度(度)", "#AD95FF"],
    // socList: ["SOC", "#F9DC76"]
    bsmTempList: [i18n.t("orderDetails.BSMMaxTemperature") + "(℃)", "#4BA3F5"],
    bcsVoltageList: [
      i18n.t("orderDetails.BCSMaxBatteryVoltage") + "(V)",
      "#6DDFCF"
    ],
    socList: ["SOC(%)", "#F9DC76"]
  };

  /**
   * 电压ichart特征
   */
  // pressureFeature = {
  //   bsmTempList: ["BSM最高动力电池温度", "#4BA3F5"],
  //   bcsVoltageList: ["BCS最高单体电池电压", "#6DDFCF"],
  //   socList: ["SOC", "#F9DC76"]
  // };

  templateData: objAny[] = [];

  pressureData: objAny[] = [];
  curveData: objAny = {};

  async getOrderCurveCharge(): Promise<void> {
    if (!this.orderNo) {
      return;
    }
    const ret = await getCurveBettery({ orderNo: this.orderNo });
    if (ret.status == this["$config"].apiStatus) {
      const data = ret.data[0];
      this.curveData = data;
      let chargeEndTime = this.infoData.chargeEndTime;
      if (
        !chargeEndTime &&
        data.bcsVoltageList &&
        data.bcsVoltageList.length > 0
      ) {
        chargeEndTime =
          data.bcsVoltageList[data.bcsVoltageList.length - 1].recTime;
      }
      //开始时间与结束时间相差几秒
      this.diffTime(this.infoData.chargeBeginTime, chargeEndTime);
      // this.convertEchartData(data, this.pressureFeature, true);

      this.convertEchartData(data, this.templateFeature, false);
      await echartsJS();
      this.loaded = true;
    }
  }
  /**
   * @param data 要转换的数据
   * @param data 要转换的数据格式
   * @param isTag  是否是电压
   */
  convertEchartData(data: objAny, dataKeys: objAny, isPressure = false): void {
    const varyData = isPressure ? this.pressureData : this.templateData;
    Object.keys(data).forEach(item => {
      if (Object.keys(dataKeys).includes(item)) {
        // const cItem = {
        //   name: dataKeys[item][0],
        //   color: dataKeys[item][1],
        //   data:
        //     data[item] &&
        //     data[item].map((vItem: objAny) => {
        //       const bItem = [vItem.recTime!, vItem.value];
        //       return bItem;
        //     })
        // };
        const list: objAny[] = [];
        if (data[item]) {
          data[item].map((vItem: objAny, index: number) => {
            if (index == 0 && vItem.recTime != this.infoData.chargeBeginTime) {
              list.push([this.infoData.chargeBeginTime, ""]);
            }
            list.push([vItem.recTime, vItem.value]);
            if (
              index == data[item].length - 1 &&
              vItem.recTime != this.infoData.chargeEndTime
            ) {
              list.push([this.infoData.chargeEndTime, ""]);
            }
          });
        }
        const cItem = {
          name: dataKeys[item][0],
          color: dataKeys[item][1],
          data: list
        };
        varyData.push(cItem);
      }
    });
  }

  /**
   * 相差时间
   * @param startTime
   * @param endTime
   */
  diffTime(startTime: string, endTime: string): void {
    if (!startTime || !endTime) {
      return;
    }
    const start = Number(new Date(startTime));
    const end = Number(new Date(endTime));
    const diff = end - start; // 得出相差几秒
    const maxIn = 20;
    if (diff / this.second > maxIn) {
      this.second = parseInt(diff / maxIn + "");
    }
  }

  async created(): Promise<void> {
    this.getOrderCurveCharge();
  }
}
